let viewport = {
        width: 0,
        height: 0
    },
    doc = document,
    root = doc.documentElement;

// Calculate the height of the Viewport ICB
// Adds CSS variables for access in CSS
let measure = () => {
    let div = doc.createElement("div");
    div.style.cssText = "position: fixed;top: 0;left: 0;bottom: 0;right: 0;";
    root.insertBefore(div, root.firstChild);

    viewport.height = div.offsetHeight;
    viewport.width = div.offsetWidth;
    root.removeChild(div);
    // Set CSS variables
    root.style.setProperty("--vh", `${viewport.height}px`);
    root.style.setProperty("--vw", `${viewport.width}px`);
};

measure();

// Lightly detect mobile browsers
if ("onorientationchange" in window) {
    window.addEventListener("orientationchange", measure);
    // Instagram loads a footer shortly after loading the page, changing the height
    setTimeout(measure, 2000);
} else {
    window.addEventListener("resize", measure);
}

export default viewport;
